import { render } from "./widget-tep-net.vue?vue&type=template&id=118e7e4e"
import script from "./widget-tep-net.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-tep-net.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-grid/components/widgets/widget-tep-net.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "118e7e4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('118e7e4e', __exports__)) {
    api.reload('118e7e4e', __exports__)
  }
  
  module.hot.accept("./widget-tep-net.vue?vue&type=template&id=118e7e4e", () => {
    api.rerender('118e7e4e', render)
  })

}


export default __exports__